<template>
    <div>
        <div class="top_title" style="padding-top: .8rem;">{{action == 'modify'?'修改':'绑定'}}支付宝账号</div>
        <div class="step1" v-if="step == 1">
            <div class="wd_tips">
                <img class="wd_icon" src="../../../assets/bx/warning.png" alt="" />
                <i>提醒：</i>您可以将钱包余额提现到支付宝账号，请确保<i>支付宝账号</i>及姓名准确无误!<i>否则会提现失败!</i>
            </div>
            <el-form class="box" :model="actionData" ref="zfb">
                <el-form-item prop="name" :rules="rules.alipayName">
                    <div class="label">姓名</div>
                    <el-input v-model="actionData.name" type="text" placeholder="支付宝姓名（真实姓名）"></el-input>
                </el-form-item>
                <el-form-item prop="account" :rules="rules.alipayAccount">
                    <div class="label">账号</div>
                    <el-input v-model="actionData.account"
                        placeholder="支付宝账号">
                    </el-input>
                </el-form-item>
                <el-form-item class="zfb" prop="third_img" :rules="rules.zfb">
                    <div class="label">支付宝账号截图</div>
                    <div class="slt">
                        <!-- <span class="pre">示例：</span>
                        <img class="slt_img" src="../../../assets/bx/slt.png" alt="" @click="previewImg"> -->
                        <van-uploader v-model="list" :max-count="1" :after-read="afterRead" :accept="'image/*'"  @delete="deleteUpload"/>
                    </div>
                   
                </el-form-item>
            </el-form>
            <el-button class="next_btn" type="primary" @click="next(1)">下一步</el-button>
            <div class="jtjc">
                <p>*截图教程</p>
                <p>1、打开支付宝，进入-我的</p>
                <p>2、点击顶部账号区域，进入-个人信息</p>
                <p>3、进入-我的主页，完成截图</p>
                <img src="../../../assets/bx/jc.jpg" alt="">
            </div>
        </div>
        <div class="step2" v-else-if="step == 2">
            <div class="wd_tips">
                <img class="wd_icon" src="../../../assets/bx/warning.png" alt=""/>
                <i>提醒：</i>请输入短信验证码进行短信验证
            </div>
            <el-form class="box" @submit.native.prevent>
                <el-form-item>请输入手机<i>{{ userData.username | plusX }}</i>收到的短信验证码</el-form-item>
                <el-form-item>
                    <div class="code_area">
                        <el-input v-model="actionData.code" type="number"
                            oninput="if(value.length > 6) value=value.slice(0, 6)" class="lwc_code" placeholder="短信验证码">
                        </el-input>
                        <el-button :class="{ 'lwc_primary': true, 'lwc_disabled': isdisabled }" :disabled="isdisabled"
                            @click="sendCode">{{ buttonName }}</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btns">
                <el-button class="pre_btn" type="default" @click="pre(2)">上一步</el-button>
                <el-button class="next_btn" type="primary" @click="next(2)">下一步</el-button>
            </div>
        </div>
        <div class="step3" v-else-if="step == 3">
            <div class="success">
                <img src="../../../assets/bx/success.png" alt="" />
                <p>支付宝{{action == 'modify'?'修改':'绑定'}}成功</p>
            </div>
            <div class="btns">
                <el-button type="default" class="pre_btn" @click="gotoWithdraw">前往提现</el-button>
                <el-button type="primary" class="next_btn" @click="complete">完成</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import {httpRequest} from '@/ajax'
    import { ImagePreview } from 'vant';
import { watch } from 'less';
    export default {
        data() {
            return {
                actionData: {
                    name: "",
                    account: "",
                    third_img: "",
                    code: "",
                },
                isdisabled: false,
                buttonName: "获取验证码",
                time: 58,
                step: 1,
                action: this.$route.query.action,
                list: []
            }
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str.length >= 6) {
                    return (
                        str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    );
                } else {
                    return str;
                }
            },
        },
        computed: {
            rules() {
                const {
                    alipayName,
                    alipayAccount,
                    zfb
                } = this.$store.getters.rules;
                return {
                    alipayName,
                    alipayAccount,
                    zfb
                };
            },
            userData() {
                return this.$store.state.userData;
            },
        },
        methods: {
            pre(i) {
                if (i == 2) {
                    this.step = 1;
                }
            },
            next(i) {
                if (i == 1) {
                    this.$refs.zfb.validate(valid => {
                        if (valid) {
                            this.step = 2;
                        }
                    });
                } else if (i == 2) {
                    var submitData = {
                        name: this.actionData.name,
                        account: this.actionData.account,
                        code: this.actionData.code,
                        third_img: this.actionData.third_img
                    }
                    if(this.$route.query.id) {
                        submitData.id = this.$route.query.id
                    }
                    this.$Ajax("wallet/recv-account-submit", submitData).then(rs => {
                        if (rs.code == 200) {
                            this.step = 3;
                        }
                    });
                }
            },
            //完成绑定
            complete() {
                this.$router.go(-1)
            },
            sendCode() {
                var that = this;
                this.isdisabled = true;
                $('.lwc_code input').focus()
                this.$Ajax("wallet/sendcode").then(rs => {
                    if (rs.code == 200) {
                        this.$toast(rs.msg);
                        that.buttonName = "重新发送(59)s";
                        let interval = window.setInterval(function () {
                            that.buttonName = "重新发送(" + that.time + ")s";
                            that.time--;
                            if (that.time < 0) {
                                that.buttonName = "重新发送";
                                that.time = 58;
                                that.isdisabled = false;
                                window.clearInterval(interval);
                            }
                        }, 1000);
                    }else {
                        that.buttonName = "重新发送";
                        that.time = 58;
                        that.isdisabled = false;
                    }
                });
            },
            previewImg() {
                ImagePreview([require('../../../assets/bx/slt.png')]);
            },
            afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';
                var that = this
                httpRequest('wallet/upload-img',file.file).then(rs => {
                    if(rs.data.code == 200) {
                        that.$toast(rs.data.msg)
                        that.list = [{url: rs.data.data.path}]
                        that.actionData.third_img = rs.data.data.path
                    }else {
                        that.$toast(rs.data.msg)
                        that.list = []
                    }
                }).catch(error => {
                    that.$toast(error.message)
                })
            },
            deleteUpload() {
                this.list = []
                this.actionData.third_img = ''
            },
            gotoWithdraw() {
                if(!this.$route.query.id) {
                    this.$router.push({
                        name: "user.withdraw",
                    });
                    return
                }
                this.$router.push({
                    name: "user.withdraw",
                    query: {
                        id: this.$route.query.id
                    }
                });
            }
        },
        watch: {
            '$route.query.id': {
                handler(e) {
                    if(e) {
                        this.$Ajax("wallet/recv-account-info", {}, "get").then(rs => {
                            if (rs.code == 200) {
                                rs.data.forEach(item => {
                                    if(item.id == e) {
                                        this.actionData.name = item.name
                                        this.actionData.account = item.account
                                        this.actionData.third_img = item.third_img
                                        this.list = [{url: item.third_img}]
                                    }
                                })
                            }
                        });
                    }
                }
                ,immediate: true
            }
            
        }
    }
</script>
<style lang="less" scoped>
        .box-item {
            background-color: #fff;
            display: flex;
            align-items: center;
            height: 3.6rem;
            padding: 0 1.6rem;
            border-radius: 0.6rem;
            font-size: 1.4rem;

            img {
                width: 1.85rem;
                height: 1.85rem;
                margin-right: 0.6rem;
            }

            .prefix {
                width: 6.8rem;
            }

            /deep/.amount_ipt {
                flex: 1;

                .el-input__inner {
                    width: 100%;
                    padding: 0;
                    border: none;
                }
            }
        }
        .wd_tips {
            height: 6rem;
            padding: 1rem;
            line-height: 2rem;
            color: #aaa;
            margin-bottom: 2rem;

            .wd_icon {
                width: 1.15rem;
                height: 1.15rem;
                margin-right: 0.4rem;
                margin-bottom: 0.35rem;
            }

            i {
                color: var(--warning);
                word-break: break-all;
            }
        }
        /deep/.el-form-item__content {
            display: flex;
            align-items: center;
            background-color: #fff;
            border-radius: 0.3rem;
            padding-left: 1.2rem;

            .label {
                width: 5rem;
                font-size: 1.3rem;
            }

            .el-input {
                flex: 1;
                border: none;
                outline: none;

                input {
                    border: none;
                    outline: none;
                    text-align: start;
                    padding: 0;
                    font-size: 1.3rem;
                }
            }

            .el-form-item__error {
                left: unset;
                right: 1.2rem;
                z-index: 10;
                top: 85%;
            }
        }
        .el-form-item {
            margin-bottom: 0;
            border-bottom: 1px solid #eee;

            i {
                color: var(--warning);
            }
            &.zfb {
                border: none;
                /deep/.el-form-item__content {
                    flex-direction: column;
                    align-items: flex-start;
                    .label {
                        width: 100%;
                    }
                }
                .slt {
                    display: flex;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    padding-bottom: 1rem;
                    .pre {
                        line-height: 1.5;
                    }
                    .slt_img {
                        cursor: pointer;
                        width: 120px;
                        height: 121px;
                    }
                }
            }
        }



        .box {
            margin-bottom: 2rem;
        }

        .next_btn {
            width: 18rem;
            height: 3rem;
            border-radius: 10rem;
            margin: 0 auto 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.2rem;
        }

        .code_area {
            width: 100%;
            height: 4.4rem;
            display: flex;
            // border: 1px solid #dcdee6;
            // border-radius: 4px;
            position: relative;

            &:hover {
                border-color: #c0c4cc;
            }

            /deep/.el-input__inner {
                height: 100%;
                font-size: 1.4rem;
                padding: 0 1.6rem;
                padding-right: 10rem;
            }

            .lwc_primary {
                position: absolute;
                right: 0.6rem;
                top: 50%;
                transform: translateY(-50%);
                -webkit-tap-highlight-color: transparent;
                border: none;
                color: var(--theme);
                font-size: 1.2rem;
                background-color: var(--xq);
                color: #fff;
                width: 8.5rem;
                height: 2.5rem;
                line-height: 2.5rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &:visited,
                &:hover,
                &:active {
                    opacity: 0.9;
                }

                &.is-disabled {
                    background-color: #999;
                }
            }
        }

        //step2
        .btns {
            display: flex;
            justify-content: space-around;

            .next_btn {
                width: 14rem;
            }

            .pre_btn {
                width: 14rem;
                height: 3rem;
                border-radius: 10rem;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 1.2rem;
                border-color: var(--theme);
                color: var(--theme);
                &:hover {
                    background-color: transparent;
                    opacity: 0.9;
                }
            }
        }

        //step3
        .success {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-color: #fff;
            padding: 4rem 0;
            border-radius: 0.4rem;
            margin-bottom: 4rem;

            img {
                width: 3.1rem;
                height: 3.1rem;
                margin-bottom: 1rem;
            }
        }

        .complete {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 3rem;
            border-radius: 10rem;
            width: 20rem;
            margin: 0 auto;
        }

        .jtjc {
            line-height: 1.8;
            img {
                margin-top: 1rem;
                width: 100%;
            }
        }
</style>